// src/theme.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'light';
    return localStorage.getItem('theme') || 'light';
  });


  useEffect(() => {
    const root = document.documentElement;
    const apply = (t) => {
      if (t === 'dark') root.classList.add('dark');
      else if (t === 'light') root.classList.remove('dark');
      else {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        prefersDark ? root.classList.add('dark') : root.classList.remove('dark');
      }
    };

    apply(theme);

    // اگر حالت system فعال است، به تغییرات pref می‌شنویم
    let mq;
    const handleChange = () => apply('system');
    if (theme === 'system') {
      mq = window.matchMedia('(prefers-color-scheme: dark)');
      if (mq.addEventListener) mq.addEventListener('change', handleChange);
      else mq.addListener(handleChange);
    }

    return () => {
      if (mq) {
        if (mq.removeEventListener) mq.removeEventListener('change', handleChange);
        else mq.removeListener(handleChange);
      }
    };
  }, [theme]);

  useEffect(() => {
    try { localStorage.setItem('theme', theme); } catch (e) { }
  }, [theme]);

  const toggle = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));
  const setSystem = () => setTheme('system');

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle, setSystem }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
